import { styled } from 'styled-components'
import { motion } from 'framer-motion'
import { screen } from '../../styles/mq'

/* switcherButton.tsx */

export const SwitcherButtonContainer = styled.div<{ $position: number }>`
  position: relative;
  margin: 3rem auto;
  height: 48px;
  width: min-content;
  border-radius: 24px;
  border: 2px solid var(--main);
  cursor: pointer;
  user-select: none;
  > div {
    position: relative;
    height: 100%;
    display: flex;
    justify-content: center;
  }
  .text {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    padding: 0 16px;
    text-wrap: nowrap;
  }
  .sign {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    left: ${({ $position }) => $position * 100}%;
    transform: ${({ $position }) =>
      $position === 2
        ? 'translateX(-100%)'
        : $position === 1
          ? 'translateX(-100%)'
          : 'none'};
    height: 100%;
    padding: 0 16px;
    border-radius: 24px;
    color: var(--light);
    font-weight: 700;
    background: var(--main);
    transition: all 0.5s;
  }
`

/* PROJECTs PREVIEWS */

export const DetailProjectsContainer = styled(motion.ul)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin: 3rem 0;
  padding: 0;
  @media (max-width: ${screen.m}) {
    grid-template-columns: 1fr;
  }
`
export const ProjectsContainer = styled(motion.ul)`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 12px;
  row-gap: 36px;
  margin: 0;
  padding: 0;
  @media (max-width: ${screen.m}) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: ${screen.s}) {
    grid-template-columns: 1fr;
  }
`
export const PreviewContainer = styled(motion.li)`
  position: relative;
  height: 100%;
  &::marker {
    color: transparent;
  }

  line-height: 0;
  .face {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  cursor: pointer;
  > div {
    position: relative;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: left top;
    transition: all 1s;
  }
  &:hover {
    img {
      transform: scale(1.02);
    }
  }
`

export const ProjectsTechnic = styled.div`
  display: inline-block;
  font-size: 1.2rem;
  line-height: normal;
  margin-right: 4px;
  margin-bottom: 6px;
  padding: 0 var(--padding-s);
  border: 1px solid var(--light);
  border-radius: 12px;
  opacity: 0.6;
  color: var(--light);
  &:last-of-type {
    margin-right: 8px;
  }
`

/* PROJECT INTRO */

export const IntroDescription = styled.div`
  flex: 0 0 auto;
  padding: var(--padding-m) 0;
  width: 100%;
  line-height: normal;
  color: var(--main);
  h2 {
    font-size: 2rem;
    color: var(--light);
    margin: 0 0 4px;
    span {
      font-size: 1.6rem;
      font-weight: normal;
      opacity: 0.6;
    }
  }
  p:nth-child(2) {
    margin-top: 4px;
  }
  p: last-child {
    margin-bottom: 0;
  }
  a {
    margin-left: 4px;
    font-size: 1.2rem;
  }
  span {
    color: var(--main);
  }
`
export const IntroLink = styled.a`
  font-size: 1.4rem;
  color: var(--highlight);
  text-decoration: none;
  border-bottom: 1px solid var(--highlight);
  &:hover {
    transition: color 0.5s;
    color: var(--light);
  }
`

/* preview.tsx */

export const PreviewImage = styled.div<{ $aspectRatio: string }>`
  aspect-ratio: ${({ $aspectRatio }) => $aspectRatio};
  aspect-ratio: 16/9;
  margin-bottom: 16px;
  overflow: hidden;
`

export const PreviewText = styled.div`
  width: 100%;
  padding: var(--padding-xs);
  color: var(--light);
`
export const PreviewName = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 0 var(--padding-xs) 0;
  line-height: normal;
  span:first-child {
    font-weight: 700;
  }
  span:last-child {
    font-size: 1.2rem;
  }
`

/* DETAILED PROJECT */

export const DetailContainer = styled.div<{ $dir: string }>`
  margin: var(--padding-l) 0 8rem;
  display: flex;
  flex-direction: ${({ $dir }) => ($dir === 'left' ? 'row' : 'row-reverse')};
  gap: var(--gap);
  h2 {
    color: var(--light);
  }
  picture {
    flex-shrink: 0;
    width: 60%;
  }
  img {
    width: 100%;
  }
  video {
    width: 60%;
  }
  div {
    display: flex;
    align-items: center;
  }
  span {
    color: var(--highlight);
  }
  @media (max-width: ${screen.m}) {
    display: block;
    margin: var(--padding-m) 0 var(--padding-l);
    img {
      width: 100%;
    }
    video {
      width: 100%;
    }
  }
`
